import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import type { IDermaCwondV1DiagnosticReportAddEditCustomControlData } from './DermaCwondV1DiagnosticReportAddEdit';
import { DermatologyPolicies } from '../../../../../../common/validation/customControls/dermatology';
import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { List, ListItem } from '../../../../elements/List/List';

export function DermaCwondV1DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    const customControlData: IDermaCwondV1DiagnosticReportAddEditCustomControlData =
        props.diagnosticReport.customControlData;

    if (!customControlData) {
        return null;
    }

    const beleid =
        customControlData.beleid !== DermatologyPolicies.anders
            ? customControlData.beleid
            : customControlData.beleidAndersText;

    return (
        <>
            {(customControlData.omschrijving_beleid || beleid) && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.policy')}</FormLabel>
                    <InputContainer>
                        <List>
                            {customControlData.omschrijving_beleid && (
                                <ListItem bold>{customControlData.omschrijving_beleid}</ListItem>
                            )}

                            {beleid && <ListItem bold>{beleid}</ListItem>}
                        </List>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {customControlData.bezoek_aan_specialist_nodig && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.visitToSpecialistNecessary')}</FormLabel>
                    <InputContainer>
                        <FormParagraph bold>{customControlData.bezoek_aan_specialist_nodig}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {customControlData.urgentie && (
                <HorizontalFormGroupRead>
                    <FormLabel>Urgentie</FormLabel>
                    <InputContainer>
                        <FormParagraph bold>{customControlData.urgentie}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
